import { useQuery } from "@tanstack/react-query";
import type { AppConfigView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

export function useAppConfigsQuery() {
  const query = useQuery({
    queryKey: queryKeys.admin.appConfigs(),
    queryFn: () => apiJsonClient<AppConfigView[]>(endpoints.admin.appConfigs),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
